import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Snackbar } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import OutlinedInput from '@mui/material/OutlinedInput';

function Region() {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true); // Loader state
  const [open, setOpen] = useState(false); // Modal state
  const [id, setId] = useState("");

  const [allData, setAllData] = useState([]); // Store all fetched data

  const [filterType, setFilterType] = useState(""); // State for filter by type
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState("");
  const [newFormData, setNewFormData] = useState({ region: "" });
  const userRole = localStorage.getItem("userRole"); // Fetch user role from localStorage
  const [addOpen, setAddOpen] = useState(false); // Add modal state
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");
  const [deleteBox, setdeleteBox] = useState(false); // Modal state
  const [genreresponseData, setgenreResponseData] = useState([]);
  const [showCustomRegion, setShowCustomRegion] = useState(false);
  const [customRegion, setCustomRegion] = useState("");


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }

      const response = await axios.get("https://api.exampladmedia.com/region/getall", {
        headers: {
          Authorization: sessionToken,
        },
      });

      const { data } = response.data;
      setAllData(data); // Store all fetched data
      applyFilters(data); // Apply filters to the data
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const applyFilters = (data) => {
    const filteredRows = [];
    let index = 1;

    data.forEach((item) => {
      if (item.region) {
        const itemRegion = item.region.toLowerCase();
        const filter = filterType.toLowerCase();

        if (!filterType || itemRegion.includes(filter)) {
          // Apply filter logic
          // if (!filterType || item.region === filterType) {
          filteredRows.push({
            srNo: index++,
            region: item.region,
            // text: item.value,
            actions: (
              <MDBox display="flex" justifyContent="center">
                {userRole === "SUPER_ADMIN" && (
                  <>
                    {/* <IconButton
                    color="primary"
                    size="small"
                    onClick={() => {
                      setFormData(item.region);
                      handleEdit(item.regionId);
                    }}
                  >
                    <EditIcon style={{ color: "green" }} />
                  </IconButton> */}
                    <IconButton
                      color="secondary"
                      size="small"
                      onClick={() => handleConfirmDelete(item.regionId)}
                    >
                      <DeleteIcon style={{ color: "red" }} />
                    </IconButton>
                  </>
                )}
              </MDBox>
            ),
          });

          // console.log(filteredRows, "filterd row ");
        }
      }
    });

    // Define table columns
    const columns = [
      { Header: "Sr. No", accessor: "srNo", align: "center" },
      { Header: "Region", accessor: "region", align: "center" },
      // { Header: "Type", accessor: "text", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ];

    setTableData({ columns, rows: filteredRows });
    setLoading(false);
  };
  console.log(selectedItem, "selectedItem");

  useEffect(() => {
    fetchData();
  }, []); // Fetch data only once on component mount

  useEffect(() => {
    if (allData.length > 0) {
      applyFilters(allData); // Apply filters whenever filterType changes
    }
  }, [filterType]); // Re-apply filters when filterType changes

  const handleConfirmDelete = async (item) => {
    setSelectedItem(item); // Set the item to be deleted

    setdeleteBox(true);
  };

  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      const response = await fetch(
        `https://api.exampladmedia.com/region/delete/${selectedItem}`,
        {
          method: "POST",
          headers: {
            "Authorization": sessionToken,
          },
        }
      );

      if (response.status === 200) {
        // setSnackbarMsg(response.data.message);
        setSnackbarMsg("Region deleted successfully!");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        fetchData(); // Refresh data after deleting
      }
    } catch (error) {
      if (error.response) {
        // Extract the error message from error.response.data.message
        const errorMessage = error.response.data.message || "An error occurred.";
        setSnackbarMsg(errorMessage);
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }

      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }

    setdeleteBox(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEdit = (item) => {
    setId(item);
    setOpen(true); // Open modal
  };

  const handleAdd = () => {
    setNewFormData({ region: "" }); // Reset the Add form data
    setAddOpen(true); // Open add modal
  };

  const handleSave = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }

      const payload = {
        value: formData,
      };

      // Make the API request
      const response = await axios.put(`https://api.exampladmedia.com/region/edit/${id}`, payload, {
        headers: {
          Authorization: sessionToken,
        },
      });

      if (response.status === 200) {
        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        fetchData(); // Refresh data after update
        setOpen(false); // Close modal
        fetchData();
      }
    } catch (error) {
      // Handle errors gracefully
      if (error.response) {
        const errorMessage = error.response.data.error || "An error occurred.";

        setSnackbarMsg(errorMessage);
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }

      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log();

  const handleAddRegion = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
        // Exit if sessionToken is not found
      }

      // Check and process newFormData
      if (!newFormData || !newFormData.region) {
        console.error("Invalid form data");
        setSnackbarMsg("Invalid input data.");
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        return;
      }
      const payload = {
        // value: newFormData.text,
        region: newFormData.region,
      };

      // Make the API request
      const response = await axios.post(`https://api.exampladmedia.com/region/add`, payload, {
        headers: {
          Authorization: sessionToken,
        },
      });
      fetchData();

      setAddOpen(false);
      // setShowCustomRegion(flase)
      if (response.status === 200) {
        console.log("Region updated:", response.data.message);

        setSnackbarMsg(response.data.message);
        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        // Close modal
      }
    } catch (error) {
      // Handle errors gracefully
      if (error.response) {
        setSnackbarMsg(error.response.data.error);
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }

      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };

  const handleDeleteCancel = () => {
    setdeleteBox(false);
  };

  console.log(tableData, "table data");
  console.log(newFormData, "newFormdata");
  //  const handleAddRegion = (value)=>{
  //         setNewFormData({ ...newFormData, region: value })
  //         fetchData()
  //  }
  const handleCloses = () => {
    setAddOpen(false);
    setShowCustomRegion(false);
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {/* Add button aligned to the left */}
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  onClick={handleAdd}
                >
                  Add
                </Button>

                <MDBox display="flex" flexDirection="column">
                  <MDBox display="flex" alignItems="center" gap={2} p={2}>
                    {/* Simple Search Input */}
                    <FormControl
                      // variant="outlined"
                      size="small"
                      style={{
                        marginLeft: "5px",
                        minWidth: 250,
                        backgroundColor: "white",
                        borderRadius: "8px",
                      }}
                    >
                      {/* <InputLabel
                        sx={{
                          color: "black",
                          backgroundColor: "white",
                          paddingX: 1,
                        }}
                        shrink
                      >
                        Search
                      </InputLabel> */}
                      <OutlinedInput
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        placeholder="Search Region"
                        sx={{
                          backgroundColor: "white",
                          color: "black",
                          paddingX: 2,
                          height: "40px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "grey",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "black",
                          },
                        }}
                      />
                    </FormControl>
                  </MDBox>
                </MDBox>

                {/* Heading centered */}
                <h2 style={{ color: "white", margin: 0, flex: 1, textAlign: "center" }}>Region</h2>
              </MDBox>
              <MDBox pt={3} px={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" alignItems="center" height="300px">
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={tableData}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={addOpen} onClose={() => setAddOpen(false)}>
        <DialogTitle>Add Region </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: "10px" }}></div>
          <MDBox mb={2}>
            <FormControl fullWidth margin="normal">
              <TextField
                label="Region"
                value={newFormData.region}
                onChange={(e) => {
                  setNewFormData({ ...newFormData, region: e.target.value });
                }}
                margin="normal"
              />
            </FormControl>
          </MDBox>

          <MDBox mb={3}>
            {/* <TextField
              label="Text"
              name="region"
              value={newFormData.text}
              onChange={(e) =>
                setNewFormData({ ...newFormData, region: e.target.value })
              }
              fullWidth
              margin="normal"
            /> */}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddRegion} style={{ color: "green" }}>
            Save
          </Button>
          <Button onClick={handleCloses} style={{ color: "red" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* edit model */}
      {/* <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Region</DialogTitle>
        <DialogContent>
          <MDBox mb={2}>
            <TextField
              label="Text"
              name="text"
              value={formData}
              onChange={(e) => setFormData(e.target.value)}
              fullWidth
              margin="normal"
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} style={{ color: "green" }}>
            Save
          </Button>
          <Button onClick={handleClose} style={{ color: "red" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
      <Snackbar
        open={openSnackbar}
        message={SnackbarMsg}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenSnackbar(false)}
      />

      {/* deletion Dialogbox */}
      <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this {selectedItem?.region || "item"}?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} style={{ color: "green" }}>
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel} style={{ color: "red" }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Region;
